import Modal from "../Modal/Modal";
import Button from "../Button/Button";
import CloseIcon from "../../assets/svg/close-icon";
import OutlookImage from "../../assets/images/Outlook.png";

interface DisconnectOutlookModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

const DisconnectOutlookModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
}: DisconnectOutlookModalProps) => {
  return (
    <Modal
      open={isOpen}
      onOpenChange={(open) => {
        if (!open && !isLoading) onClose();
      }}
      showHeader={false}
      preventOutsideClick={isLoading}
      closeOnEscape={!isLoading}
      contentClassName="w-[454px] bg-pure-white dark:bg-pure-white-dk rounded-[8px] pt-6! pb-8! px-6!"
      overlayClassName="bg-black/50"
      bodyClassName="p-0! w-full"
    >
      <div className="flex flex-col gap-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img
              src={OutlookImage}
              alt="Outlook"
              className="w-6 h-6 shrink-0 object-contain"
            />
            <h3 className="text-xl font-semibold text-heading-text dark:text-heading-text-dk">
              Disconnect Outlook
            </h3>
          </div>
          <Button
            Icon={CloseIcon}
            onClick={onClose}
            disabled={isLoading}
            buttonContainerClass="shrink-0 w-5 h-5 bg-heading-text dark:bg-heading-text-dk rounded-full flex flex-col items-center justify-center transition-transform duration-200"
            iconClass="w-2 h-2 text-pure-white dark:text-pure-white-dk"
          />
        </div>

        <p className="text-md text-verba-field-label dark:text-verba-field-label-dk">
          Once disconnected, you'll no longer be able to send emails from your
          Outlook account. Continue?
        </p>

        <div className="flex items-center justify-end gap-2">
          <Button
            innerText="No, Cancel"
            onClick={onClose}
            disabled={isLoading}
            buttonContainerClass="px-3 py-[9px] rounded-[6px] bg-heading-text dark:bg-heading-text-dk hover:opacity-90 transition-opacity duration-200"
            innerTextClass="text-md font-medium text-pure-white dark:text-pure-white-dk"
          />
          <Button
            innerText="Yes, Disconnect Outlook"
            isLoading={isLoading}
            disabled={isLoading}
            onClick={onConfirm}
            buttonContainerClass="px-3 py-[9px] rounded-[6px] border border-tags-red-border dark:border-tags-red-border-dk bg-transparent hover:opacity-90 transition-opacity duration-200 disabled:opacity-50"
            innerTextClass="text-md font-medium text-tags-red-border dark:text-tags-red-border-dk"
          />
        </div>
      </div>
    </Modal>
  );
};

export default DisconnectOutlookModal;
